var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 238574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Blue_1_",
    d: "M38.2683 40.75C39.5099 40.75 40.5 39.7442 40.5 38.5183V2.48166C40.5 1.2401 39.4942 0.25 38.2683 0.25H2.23167C1.00582 0.25 0 1.25582 0 2.48166V38.5183C0 39.7599 1.00582 40.75 2.23167 40.75H38.2683Z",
    fill: "#3A5895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M27.9426 40.7498V25.0653H33.2075L33.9933 18.9518H27.9426V15.0542C27.9426 13.2783 28.4298 12.0839 30.9758 12.0839H34.2133V6.59902C33.6475 6.52044 31.7302 6.36328 29.4985 6.36328C24.8309 6.36328 21.6405 9.20787 21.6405 14.4413V18.9518H16.36V25.0653H21.6405V40.7498H27.9426Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a3d511f64d03c359aa8f15d33477c0a0.svg";
export { ForwardRef as ReactComponent };